import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type { RecordingPayload } from '@Application/Beneficiaries/Interviews/Actions/interviewsFetched';
import recordingCompleted, {
	type RecordingCompletedAction,
} from '@Application/Beneficiaries/Interviews/Actions/recordingCompleted';
import recordingCompletionFailed, {
	type RecordingCompletionFailedAction,
} from '@Application/Beneficiaries/Interviews/Actions/recordingCompletionFailed';
import type CompleteRecording from '@Application/Beneficiaries/Interviews/Commands/CompleteRecording';
import { put } from '@Domain/Api';
import ApiError from '@Infra/FetchLib/ApiError';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import type * as React from 'react';

type Actions = RecordingCompletedAction | RecordingCompletionFailedAction;

/** Dispatched by the transfer handler through its own `dispatch`: R6 finalises the recording once every segment has been transferred. */
const completeRecording = (command: CompleteRecording) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await put<RecordingPayload>(
				`${buildSubjectApiPath(command.facilityId, command.subject)}/interviews/${command.interviewId}/recordings/${command.recordingId}`,
				command.toJSON(),
			);

			const action = recordingCompleted(
				payload,
				command.interviewId,
				command.subject.typeKey,
				command.subject.subjectId,
			);
			dispatch(action);
			return action;
		} catch (error) {
			const action = recordingCompletionFailed(
				extractMessages(error),
				error instanceof ApiError ? error.status : null,
			);
			dispatch(action);
			return Promise.reject(action);
		}
	};
};

export default completeRecording;
